// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"19ba37eb","139":"0b3ba502","193":"5dcd4ec1","302":"f27e2d5f","465":"48053e2f","517":"45d0f0c6","588":"84646f98","635":"8a13dd8c","653":"072d6667","705":"97ab6950","743":"49a3ac0f","818":"2ce72da3","891":"b9596c49"}[chunkId] + ".chunk.js";
};